import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

// mui components
import { Stack } from "@mui/material";

// custom components
import EmptyTextContainer from "../../empty-text-container";
import { TabPanel } from "../../tab-panel";
import RequiredError from "../../required-error";
import EligibleFilter from "../../loan-form-card/eligible-filter";
import IneligibleFilter from "../../loan-form-card/ineligible-filter";
import TemporaryDrawer from "../../temporary-drawer";

// api slices
import { useGetEligibleProductDetailsMutation } from "../../../features/get-eligible-product-details/getEligibleProductDetailsApiSlice";
import { useGetIneligibleProductsMutation } from "../../../features/get-ineligible-products/getIneligibleProductsApiSlice";
import { useFieldMutation } from "../../../features/field-values/fieldValueApiSlice";
import { useCreateOBReLockRequestMutation } from "../../../features/create-OB-relock-request/createOBReLockRequestApiSlice";
import { useUpdateFieldsMutation } from "../../../features/update-fields/updateFieldsApiSlice";
import { useGetReLockProductSearchMutation } from "../../../features/get-relock-product-search/getReLockProductSearchApiSlice";
// redux slice
import { selectUserDetails, selectSelectedOrganization } from "../../../features/auth/authSlice";
import { selectImpersonatedUser } from "../../../features/admin/impersonated-user/impersonatedUserSlice";

// custom modal
import LoaderTextModal from "../../modal/loader-text-modal";
import SuccessModal from "../../modal/success-modal";
import ErrorModal from "../../modal/error-modal";
import PricingModal from "../../modal/pricing-modal";
import ProcessingModal from "../../modal/processing-modal";
import LoaderModal from "../../modal/loader-modal";

//utils
import {
	BROKER_ADMIN,
	LOAN_CHANNEL_CONSTANTS,
	TPO_SECONDARY,
} from "../../../utils/common-constants";
import {
	selectedUserWithAccessLevel,
	selectedUserWithLoanChannel,
} from "../../../utils/common-helpers";

// custom styles
import styles from "./index.module.scss";

const ReLockLoanPricingCard = (
	{
		loanData,
		loanGuid,
		setIsPriceLoanDisabled,
		getFieldValuesOnLoanSummary,
		obLoanID,
		obEntityID,
		obUserID,
		goToDefaultView,
	},
	ref
) => {
	const params = useParams();

	// Expose the childMethod using a ref
	React.useImperativeHandle(ref, () => ({
		handleSubmitApplication: () => handleSubmitApplication(),
	}));

	console.log("50 loan id:", loanGuid);

	const [tabValue, setTabValue] = useState(0);
	function a11yProps(index) {
		return {
			id: `simple-tab-${index}`,
			"aria-controls": `simple-tabpanel-${index}`,
		};
	}

	const [field] = useFieldMutation();
	const [updateFields, { isLoading: isUpdatingFields }] =
		useUpdateFieldsMutation();
	const [
		getEligibleProductDetails,
		{ isLoading: isGettingEligibleProductDetails },
	] = useGetEligibleProductDetailsMutation();
	const [getIneligibleProducts, { isLoading: isGettingIneligibleProducts }] =
		useGetIneligibleProductsMutation();
	const [createOBReLockRequest, { isLoading: isCreatingOBReLockRequest }] =
		useCreateOBReLockRequestMutation();
	const [getRelockProductSearch, { isLoading: isGettingRelockProductSearch }] =
		useGetReLockProductSearchMutation();
	const getLastName = (fullName) => {
		if (!fullName) return null;
		const parts = fullName.trim().split(" ");
		return parts[parts.length - 1];
	};
	console.log("23 params:", params);
	console.log("23 loan id:", loanGuid);

	const [eligibleProducts, setEligibleProducts] = useState([]);
	const [expandedProduct, setExpandedProduct] = useState("");
	const [eligibleProductDetails, setEligibleProductDetails] = useState({});
	const [selectedRow, setSelectedRow] = useState({});
	const [selectedProduct, setSelectedProduct] = useState({});
	console.log("40 selected product:", selectedProduct);
	console.log("40 selected eligible sub product:", selectedRow);

	const [ineligibleProducts, setIneligibleProducts] = useState([]);

	const [drawerData, setDrawerData] = useState({});
	const [drawerType, setDrawerType] = useState("");
	const [drawerOpen, setDrawerOpen] = useState({});

	const [loanProgram, setLoanProgram] = useState("");
	const [loanEmail, setLoanEmail] = useState("");
	const [orgLoanChannel, setOrgLoanChannel] = useState("");

	const [compensationPlan, setCompensationPlan] = useState("");

	const userDetails = useSelector(selectUserDetails);
	const impersonatedUser = useSelector(selectImpersonatedUser);
	const selectedOrganization = useSelector(selectSelectedOrganization);

	const handleOpenDrawer = () => {
		setDrawerOpen({
			right: true,
		});
	};

	const handleCloseDrawer = () => {
		setDrawerOpen({
			right: false,
		});
	};

	console.log("100 all products:", eligibleProducts);
	console.log("100 expanded id:", expandedProduct);
	console.log("100 product details:", eligibleProductDetails);

	const toggleDrawer = (event, drawerType, rowData) => {
		if (drawerType !== undefined && drawerType !== "") {
			console.log("eligible products:", eligibleProducts);
			console.log("expanded product:", expandedProduct);

			const parentProductDetails = eligibleProducts?.data?.products?.filter(
				(product) => product?.productId === expandedProduct
			);

			console.log("parent product details:", parentProductDetails);

			setDrawerData({
				loanData: loanData,
				parentProductDetails: parentProductDetails[0],
				productDetails: eligibleProductDetails,
				rowData: rowData,
			});
			setDrawerType(drawerType);
			handleOpenDrawer();
		} else {
			setDrawerType("");
			handleCloseDrawer();
		}
	};

	const [processingText, setProcessingText] = useState("");
	const [processingModalVisible, setProcessingModalVisible] = useState(false);

	const handleOpenProcessingModal = () => {
		setProcessingModalVisible(true);
	};

	const handleCloseProcessingModal = () => {
		setProcessingModalVisible(false);
	};

	const [successText, setSuccessText] = useState("");
	const [successModalVisible, setSuccessModalVisible] = useState(false);

	const handleOpenSuccessModal = () => {
		setSuccessModalVisible(true);
	};

	const handleCloseSuccessModal = () => {
		setSuccessModalVisible(false);
		getFieldValuesOnLoanSummary();
		goToDefaultView();
	};

	const [errorText, setErrorText] = useState("");
	const [errorHeadingText, setHeadingErrorText] = useState("");
	const [errorModalVisible, setErrorModalVisible] = useState(false);

	const handleOpenErrorModal = () => {
		setErrorModalVisible(true);
	};

	const handleCloseErrorModal = () => {
		setErrorModalVisible(false);
		goToDefaultView();
	};

	const [pricingModal, setPricingModal] = useState(false);

	const handleOpenPricingModal = () => {
		setPricingModal(true);
	};

	const handleClosePricingModal = () => {
		setPricingModal(false);
	};

	const handleSubmitPricingModal = async () => {
		console.log("100 eligible products:", eligibleProducts);
		console.log("100 expanded product:", expandedProduct);
		console.log("85 selected sub products", selectedRow);

		var formData = new FormData();
		formData.append("ob_loan_id", obLoanID);
		formData.append("ob_business_channel_id", obEntityID);
		formData.append("ob_originator_id", obUserID);

		const lastName = getLastName(loanData?.titleHolderName1);
		formData.append("product_id", expandedProduct);
		formData.append("search_id", eligibleProducts?.data?.searchId);
		formData.append("rate", selectedRow?.rate);
		formData.append("price", selectedRow?.price);
		formData.append("lock_period", selectedRow?.lockPeriod);
		formData.append("loanguid", loanData?.encompassId);
		formData.append("borrower_last_name", lastName);
		formData.append(
			"submitted_by",
			userDetails.first_name + " " + userDetails.last_name
		);
		formData.append("company_name", selectedOrganization);
		formData.append("email", userDetails.email);
		formData.append("encompass_loan_number", loanData.loanNumber);
		formData.append("source_area","Relock");
		try {
			const createOBReLockRequestData = await createOBReLockRequest({
				formData,
			}).unwrap();

			if (
				createOBReLockRequestData?.message?.toLowerCase()?.includes("success")
			) {
				// add logic if required
				console.log("Relock Request Submitted");
				handleOpenSuccessModal();
				setSuccessText(
					`Your relock request has been submitted to Logan Finance.`
				);
			}
		} catch (err) {
			console.log(
				"ReLoanPricingCard:handleSubmitPricingModal:createOBReLockRequest:err",
				err
			);
			handleClosePricingModal();
			if (err?.status_code === 409) {
				setHeadingErrorText("Loan File in Use");
				setErrorText(
					"Please try again later as the loan is currently being accessed by the Lock Desk. If you continue to receive this message for more than 1 hour, please contact your Account Manager for assistance."
				);
			} else {
				setErrorText(err?.data?.message);
			}

			handleOpenErrorModal();
			return;
		}
	};

	const [error, setError] = useState("");

	const getIneligibleProductList = async ({
		ob_business_channel_id,
		ob_originator_id,
		ob_loan_id,
		searchId,
	}) => {
		try {
			console.log("200 eligibleProducts:", eligibleProducts);

			const ineligibleProductList = await getIneligibleProducts({
				ob_business_channel_id,
				ob_originator_id,
				ob_loan_id,
				searchId,
			}).unwrap();

			console.log(
				"120 ineligible products:",
				ineligibleProductList?.data?.ineligibleProducts
			);
			setIneligibleProducts(ineligibleProductList?.data?.ineligibleProducts);
		} catch (err) {
			console.log("270 error:", err);
			setErrorText(
				err?.data?.message?.errors || "Error fetching ineligible products."
			);
			handleOpenErrorModal();
		}
	};

	const getEligibleProductList = async () => {
		console.log("Loan ID:", loanGuid);

		try {
			const formData = new FormData();
			formData.append("ob_loan_id", obLoanID);
			formData.append("ob_business_channel_id", obEntityID);
			formData.append("ob_originator_id", obUserID);

			// Fetch eligible products
			const response = await getRelockProductSearch({ formData }).unwrap();
			
			console.log("Eligible products response:", response);

			if (response?.status?.toLowerCase()?.includes("success")) {
				// Filter products based on loanProgram
				const filteredProducts =
					response?.data?.products?.filter(
						(product) => product.productName === loanProgram
					) || [];

				// Create a new object to update state
				const updatedEligibleProducts = {
					...response,
					data: {
						...response.data,
						products: filteredProducts,
					},
				};

				console.log("Updated Eligible Products:", updatedEligibleProducts);

				// Update state (always a new reference)
				setEligibleProducts(updatedEligibleProducts);

				// Fetch ineligible products separately
				getIneligibleProductList({
					ob_business_channel_id: obEntityID,
					ob_originator_id: obUserID,
					ob_loan_id: obLoanID,
					searchId: response?.data?.searchId,
				});
			} else {
			}
		} catch (err) {
			console.log("ReLoanPricingCard:getEligibleProductList:err", err);
			if (err?.data?.data?.errors?.includes("locked status")) {
				setErrorText(
					"We are unable to request a lock at this moment. Loan is in locked status."
				);
			} else if (err?.data?.data?.errors?.includes("LockPending status")) {
				setErrorText(
					"A lock request cannot be made at this time because a lock request is currently pending for this loan."
				);
			} else if (
				err?.data?.message?.toLowerCase()?.includes("locked by another user")
			) {
				setErrorText(
					"This Loan is currently Locked, If you need to update the lock on this loan, please contact Logan's lock desk."
				);
			} else {
				if (err?.status_code === 409) {
					setHeadingErrorText("Loan File in Use");
					setErrorText(
						"Please try again later as the loan is currently being accessed by the Lock Desk. If you continue to receive this message for more than 1 hour, please contact your Account Manager for assistance."
					);
				} else {
					setErrorText(
						err?.data?.message?.errors ||
							"Error fetching Relock eligible products."
					);
				}
			}
			handleOpenErrorModal();
		}
	};

	const handleGetEligibleProductDetails = async (productId) => {
		console.log("160 product id:", productId);

		try {
			const eligibleProductResponse = await getEligibleProductDetails({
				ob_business_channel_id: obEntityID,
				ob_originator_id: obUserID,
				ob_loan_id: obLoanID,
				search_id: eligibleProducts?.data?.searchId,
				product_id: productId,
			}).unwrap();

			console.log("120 eligible product details:", eligibleProductResponse);

			setEligibleProductDetails(eligibleProductResponse);
		} catch (err) {
			console.log("270 error:", err);
			setErrorText(
				err?.data?.message?.errors || "Error fetching eligible product details."
			);
			handleOpenErrorModal();
		}
	};

	useEffect(() => {
		if (!obLoanID || !obEntityID || !obUserID || !loanProgram) return;
		getEligibleProductList();
	}, [obLoanID, obEntityID, obUserID, loanProgram]);

	const findFieldValue = (fieldValues, fieldId) => {
		return fieldValues?.find((o) => o.fieldId === fieldId)?.value;
	};

	const updateField = (fieldValues) => {
		console.log("88 field values:", fieldValues);

		setLoanProgram(findFieldValue(fieldValues, "1401"));
		setLoanEmail(findFieldValue(fieldValues, "3968"));
		setOrgLoanChannel(findFieldValue(fieldValues, "TPO.X14"));
		setCompensationPlan(
			fieldValues?.find((o) => o.fieldId === "LCP.X1")?.value
		);
	};

	const getFieldValues = async (loanId) => {
		console.log("135 loan id:", loanId);
		try {
			const getValues = await field({
				loan_guid: loanId,
				fields: "1401,3968,TPO.X14,LCP.X1,TPO.X62,TPO.X75",
			}).unwrap();
			console.log("175 all fields:", getValues?.response);
			if (getValues?.response?.length > 0) {
				updateField(getValues?.response);
			}
		} catch (err) {
			console.log("584 error:", err);
		}
	};

	useEffect(() => {
		console.log("555 loan Guid:", loanGuid);

		if (loanGuid !== undefined && loanGuid !== "") {
			getFieldValues(loanGuid);
		}
	}, [loanGuid]);

	useEffect(() => {
		if (Object.keys(selectedRow)?.length > 0) {
			setIsPriceLoanDisabled(false);
		} else {
			setIsPriceLoanDisabled(true);
		}
	}, [selectedRow]);

	const handleSubmitApplication = async () => {
		console.log("502 params id:", params?.id);
		console.log("502 loan id:", loanGuid);

		setError("");
		handleOpenPricingModal();
	};

	const handleToggleExpand = (productId) => {
		if (expandedProduct === productId) {
			setExpandedProduct("");
		} else {
			setExpandedProduct(productId);
			handleGetEligibleProductDetails(productId);
		}
	};

	const updateFieldsAndRunPricing = async () => {
		let valuesArr = [];

		// Update Encompass field values
		if (
			(selectedUserWithLoanChannel(userDetails, impersonatedUser, selectedOrganization)
				?.loan_channel === LOAN_CHANNEL_CONSTANTS.CB ||
				selectedUserWithLoanChannel(userDetails, impersonatedUser, selectedOrganization)
					?.loan_channel === LOAN_CHANNEL_CONSTANTS.WHS) &&
			compensationPlan !== ""
		) {
			valuesArr.push({ id: "LCP.X1", value: compensationPlan });

			if (compensationPlan === "Lender Paid") {
				valuesArr.push({ id: "389", value: "" });
				valuesArr.push({ id: "1620", value: "" });
			}
		}

		try {
			const updateFieldValues = await updateFields({
				loan_guid: loanGuid || params?.id,
				field_values: valuesArr,
			}).unwrap();

			console.log(
				"LoanPricingApplication: updateFieldsAndRunPricing: updateFieldValues",
				updateFieldValues
			);

			if (
				updateFieldValues?.response === "Field values updated successfully."
			) {
				setError("");
			} else {
				console.log(
					"LoanPricingApplication: updateFieldsAndRunPricing: else err",
					updateFieldValues?.response
				);
				setError(updateFieldValues?.response);
				return;
			}
		} catch (err) {
			console.log(
				"LoanPricingApplication: updateFieldsAndRunPricing: catch err",
				err
			);
			return;
		}

		if (loanEmail !== undefined && loanEmail !== "") {
			getEligibleProductList();
		}
	};

	return (
		<>
			<Stack direction="column" className={styles.stackContainer}>
				<Stack className={styles.bodyContainer}>
					{eligibleProducts?.data?.products?.length > 0 ? (
						<EligibleFilter
							eligibleProducts={eligibleProducts?.data?.products}
							expandedProduct={expandedProduct}
							toggleExpand={handleToggleExpand}
							eligibleProductDetails={eligibleProductDetails?.data}
							selectedRow={selectedRow}
							setSelectedRow={setSelectedRow}
							setSelectedProduct={setSelectedProduct}
							toggleDrawer={toggleDrawer}
							hidePriceColumn={
								selectedUserWithAccessLevel(userDetails, impersonatedUser)
									?.access_level === TPO_SECONDARY ||
								selectedUserWithAccessLevel(userDetails, impersonatedUser)
									?.access_level === BROKER_ADMIN
									? false
									: selectedUserWithLoanChannel(userDetails, impersonatedUser, selectedOrganization)
											?.loan_channel === LOAN_CHANNEL_CONSTANTS.NDC ||
										selectedUserWithLoanChannel(userDetails, impersonatedUser, selectedOrganization)
											?.loan_channel === LOAN_CHANNEL_CONSTANTS.CORR
							}
							hidePointsPercentageColumn={
								selectedUserWithAccessLevel(userDetails, impersonatedUser)
									?.access_level === TPO_SECONDARY
									? false
									: selectedUserWithLoanChannel(userDetails, impersonatedUser, selectedOrganization)
											?.loan_channel === LOAN_CHANNEL_CONSTANTS.NDC ||
										selectedUserWithLoanChannel(userDetails, impersonatedUser, selectedOrganization)
											?.loan_channel === LOAN_CHANNEL_CONSTANTS.CORR
							}
							hidePointsValueColumn={
								selectedUserWithAccessLevel(userDetails, impersonatedUser)
									?.access_level === TPO_SECONDARY
									? false
									: selectedUserWithLoanChannel(userDetails, impersonatedUser, selectedOrganization)
											?.loan_channel === LOAN_CHANNEL_CONSTANTS.NDC ||
										selectedUserWithLoanChannel(userDetails, impersonatedUser, selectedOrganization)
											?.loan_channel === LOAN_CHANNEL_CONSTANTS.CORR
							}
							hideEligibleProductFilters={true}
							isRelock={true}
						/>
					) : (
						<EmptyTextContainer
							headerText="No products available"
							bodyText={`No eligible products are available ` +  eligibleProducts?.data?.products?.length}
						/>
					)}

					<TabPanel
						index={1}
						value={tabValue}
						className={tabValue === 1 ? styles.tabPanelContainer : ""}
					>
						{ineligibleProducts?.length > 0 ? (
							<IneligibleFilter ineligibleProducts={ineligibleProducts || []} />
						) : (
							<EmptyTextContainer
								headerText="No products available"
								bodyText={`There are no Ineligible products available for this loan`}
							/>
						)}
					</TabPanel>
				</Stack>

				{/* loan flow error */}
				{error !== "" && (
					<RequiredError
						headerText="Missing fields"
						text={
							error.includes("Something went wrong")
								? "Updates Not Received by LOS. Please Try Again."
								: error.includes("provide a value")
									? "Please provide a value for all fields highlighted above."
									: error
						}
					/>
				)}

				{/* drawer */}
				<TemporaryDrawer
					// drawer props
					drawerOpen={drawerOpen}
					drawerDirection="right"
					drawerType={drawerType}
					toggleDrawer={toggleDrawer}
					handleCloseDrawer={handleCloseDrawer}
					handleOpenProcessingModal={handleOpenProcessingModal}
					handleCloseProcessingModal={handleCloseProcessingModal}
					setProcessingText={setProcessingText}
					handleOpenSuccessModal={handleOpenSuccessModal}
					setSuccessText={setSuccessText}
					handleOpenErrorModal={handleOpenErrorModal}
					setErrorText={setErrorText}
					// custom props
					drawerData={drawerData}
				/>
				{/* custom modals */}
				<LoaderTextModal
					open={
						isGettingEligibleProductDetails ||
						isGettingRelockProductSearch ||
						isGettingIneligibleProducts
					}
					loadingTextLine1={"Obtaining Pricing & Eligibility"}
					loadingTextLine2={"This will take a few minutes"}
				/>

				<LoaderTextModal
					open={isCreatingOBReLockRequest}
					loadingTextLine1={"Submitting your Lock Request"}
					loadingTextLine2={"This will take a few minutes"}
				/>
				<LoaderModal open={isUpdatingFields} />
				<ProcessingModal open={processingModalVisible} text={processingText} />
				<SuccessModal
					open={successModalVisible}
					handleClose={handleCloseSuccessModal}
					text={successText}
				/>
				<ErrorModal
					open={errorModalVisible}
					text={errorText}
					title={errorHeadingText}
					handleClose={handleCloseErrorModal}
				/>
				<PricingModal
					open={pricingModal}
					data={selectedRow}
					productName={selectedProduct}
					confirmText="Request Rate Re-Lock"
					handleConfirm={handleSubmitPricingModal}
					closeText="Go back"
					handleClose={handleClosePricingModal}
				/>
			</Stack>
		</>
	);
};

export default React.forwardRef(ReLockLoanPricingCard);
